
import Vue from 'vue';
import { mapState, mapGetters } from 'vuex';
import axios from 'axios';

import { FeatureFlagsService } from '@/services/FeatureFlagsService';
import { NotificationService } from '@/services/NotificationService';
import { ScreenRecorderService } from '@/services/ScreenRecorderService';
import { RolesService } from '@/services/RolesService';
import { StaticDataService } from '@/services/StaticDataService';
import { pages } from '@/pages';
import { TranslationService } from '@/services/TranslationService';
import { Page } from '@/models/page-models/Page';
import { dateFormat } from '@/helpers/dateFormat';

export default Vue.extend({
  name: 'CNavDrawer',
  data(): any {
    return {
      currentLang: 'en',
      drawer: false,
      right: null,
      currentRole: null,
      recordingStatus: false,
      filterMentions: true,
      notificationLoader: false
    }
  },
  computed: {
    userAdditionalText: function(): string {
      const userRoleArray = this.$store.state.user.role;
      return userRoleArray.length <= 1 ? `${userRoleArray[0]}` : 'Multi-role'
    },
    showLogout: function(): boolean {
      if(this.$store.state.user.role.includes('Production | Operator')) {
        return this.$store.state.user.operatorId > -1;
      }
      return true;
    },
    langOptions: function(): { value: string, text: string}[] {
      return TranslationService.translateLangOptions();
    },
    ...mapState(['user']),
    ...mapState({
      allNotifications: (state: any) => state.notifications.allNotifications,
      unreadNotificationsCount: (state: any) => state.notifications.unreadCount
    }),
    ...mapGetters(['appData']),
  },
  async mounted() {
    this.currentLang = this.$store.state.language;
    this.$watch(() => this.$store.state.user, async (user: any) => {
      this.currentRole = this.$store.getters.role;
      if (user.loggedIn) {
        await FeatureFlagsService.init();
        this.notificationLoader = true;
        NotificationService.init();
        this.notificationLoader = false;
        this.filterMentions = NotificationService.filterMentions;
        StaticDataService.init();
      }
    });
  },
  methods: {
    getNavItems(): Array<any> {
      const allPages : any = [];
      const allRoles = this.$store.getters.role.split(',');
      allRoles.forEach((role: string) => {
        if (allRoles.length > 1) {
          allPages.push({
            name: `${role.toUpperCase()}`,
            isLabel: true,
          })
        }
        allPages.push(...RolesService.getNavMenu(role));
      });
      return [
        ...allPages,
        {
          name: 'Login',
          if: !this.$store.state.user.loggedIn,
          href: 'login'
        },
        {
          name: 'Operator',
          if: this.$store.state.user.loggedIn && this.$store.state.user.role.includes('Production | Operator') && !(this.$store.state.user.operatorId > -1),
          href: 'operator'
        }
      ]
    },
    async onChangeRole() {
      await axios.post('/api/v1/users/initializeRole', {
        id: this.$store.state.user._id,
        role: this.currentRole,
        changeActiveRole:true
      });
      await this.$store.dispatch('refreshUser');
      this.$store.commit('setSnackbar', { serverMessage: 'Role changed successfully', show: true, color: 'primary' });
      const page = pages.find((page: Page) => page.visible && page.forRole.split(',').map((role: string) => RolesService.allRoles[role]).includes(this.currentRole));
      if (page) {
        this.$router.push(`/${page.path}`)
      } else if (this.$route.name) {
        this.$router.push('/');
      } 
    },
    onChangeLang() {
      this.$store.commit('setLanguage', this.currentLang);
    },
    startRecording() {
      ScreenRecorderService.startRecording();
      this.recordingStatus = true;
    },
    stopRecording() {
      ScreenRecorderService.stopRecording();
      this.recordingStatus = false;
    },
    logout() {
      if (this.$store.state.user.role.includes('Production | Operator') && this.$store.state.user.operatorId > -1) {
        this.operatorLogout();
      } else {
        this.emailLogout();
      }
    },
    async emailLogout() {
      try {
        const logoutResponse = await axios.get('/api/v1/logout');
        this.drawer = false;
        this.$store.commit('resetUser');
        this.$router.push('/');
        this.$store.commit('setSnackbar', { serverMessage: logoutResponse.data.mess, show: true, color: 'primary' });
      } catch (error) {
        this.$store.commit('setSnackbar', { serverMessage: 'Logout Failed', show: true, color: 'error' });
      }
    },
    async operatorLogout() {
      try {
        const logoutResponse = await axios.post('/api/v1/operator/logout');
        this.drawer = false;
        this.$store.commit('resetUser');
        this.$router.push('/operator');
        this.$store.commit('setSnackbar', { serverMessage: logoutResponse.data.mess, show: true, color: 'primary' });
      } catch (error) {
        this.$store.commit('setSnackbar', { serverMessage: 'Logout Failed', show: true, color: 'error' });
      }
    },
    loadHome() {
      this.$router.push('/');
    },
    async markNotificationRead(notificationId: number) {
      await NotificationService.markNotificationAsRead(notificationId);
    },
    async markNotificationUnread(notificationId: number) {
      await NotificationService.markNotificationAsUnread(notificationId);
    },
    async openNotification(notificationItem: any) {
      if(!notificationItem.isRead) {
        await this.markNotificationRead(notificationItem._id);
      }
      this.$router.push(notificationItem.url);
    },
    async markAllNotificationRead() {
      await NotificationService.markAllNotificationAsRead();
    },
    formatNotificationTime(timestamp: string): string {
      return dateFormat(timestamp, 'calendar');
    },
    async toggleDirectMentions() {
      this.notificationLoader = true;
      NotificationService.filterMentions = this.filterMentions;
      await NotificationService.getCurrentNotifications();
      this.notificationLoader = false;
    }
  }
});
